import { useEffect, useRef } from "react";

/**
 * Hook que escucha los eventos de subida y aplica/remueve una clase CSS
 * al botón de submit del formulario de propiedades para bloquearlo.
 *
 * Usa eventos:
 *  - property-upload-start
 *  - property-upload-end
 */
const STYLE_ID = "property-uploading-style";
const BUTTON_SELECTOR = "#property-submit-button";
const DISABLED_CLASS = "mx-uploading-block";

const onSendEventBlockerStart = () => {
  window.dispatchEvent(new Event("property-upload-start"));
};
const onSendEventBlockerEnd = () => {
  window.dispatchEvent(new Event("property-upload-end"));
};

export { onSendEventBlockerStart, onSendEventBlockerEnd };

export default function useUploadingBlocker() {
  const counterRef = useRef(0);

  useEffect(() => {
    // Inyectar estilo global una sola vez
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement("style");
      style.id = STYLE_ID;
      style.innerHTML = `
        ${BUTTON_SELECTOR}.${DISABLED_CLASS} {
          pointer-events: none !important;
          opacity: 0.6;
          filter: grayscale(0.2);
          cursor: not-allowed !important;
        }
      `;
      document.head.appendChild(style);
    }

    const apply = () => {
      const el = document.querySelector(BUTTON_SELECTOR) as HTMLElement | null;
      if (!el) return;
      if (counterRef.current > 0) el.classList.add(DISABLED_CLASS);
      else el.classList.remove(DISABLED_CLASS);
    };

    const onStart = () => {
      counterRef.current = counterRef.current + 1;
      apply();
    };
    const onEnd = () => {
      counterRef.current = Math.max(0, counterRef.current - 1);
      apply();
    };

    window.addEventListener("property-upload-start", onStart);
    window.addEventListener("property-upload-end", onEnd);

    // Intentar aplicar por si el botón ya existe (montaje tardío del hook)
    apply();

    return () => {
      window.removeEventListener("property-upload-start", onStart);
      window.removeEventListener("property-upload-end", onEnd);
      // Asegurar que no quede bloqueado si se desmonta con cargas pendientes
      counterRef.current = 0;
      const el = document.querySelector(BUTTON_SELECTOR) as HTMLElement | null;
      if (el) el.classList.remove(DISABLED_CLASS);
      // No removemos el style para permitir hot reload sin parpadeos
    };
  }, []);
}
